var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3393_8571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1333 3.82223V1.95557",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.82223V1.95557",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8667 3.82223V1.95557",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42223 2.88892H2.57779C2.23414 2.88892 1.95557 3.16749 1.95557 3.51114V9.42225C1.95557 9.76589 2.23414 10.0445 2.57779 10.0445H9.42223C9.76588 10.0445 10.0445 9.76589 10.0445 9.42225V3.51114C10.0445 3.16749 9.76588 2.88892 9.42223 2.88892Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82227 6H8.17782",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82227 7.8667H6.31115",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3393_8571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.71111,
    height: 8.71111,
    fill: "white",
    transform: "translate(1.64453 1.64441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidity);
export default __webpack_public_path__ + "static/media/validity.e7791a20564dd65df90c01f04a768f7a.svg";
export { ForwardRef as ReactComponent };